import { SubmissionContextData } from "@/context/AppContext";

export function submissionFormValid({
  week,
  defaultWeek,
  overrideDefaultWeek,
}: SubmissionContextData) {
  return (defaultWeek !== null && !overrideDefaultWeek) || week !== null;
}
